import { OMT_AssetLoader } from '../../js/Services/OMT/OMT_AssetLoader';

if (typeof G == 'undefined') G = {};

Math.sign = Math.sign || function (x) {
  x = +x; // convert to a number
  if (x === 0 || isNaN(x)) {
    return x;
  }
  return x > 0 ? 1 : -1;
}

G.adAndVisibilityCheck = function (cb) {
  if (typeof cb !== 'function') {
    throw new Error('Must pass callback into adAndVisibilityCheck()');
  }

  const shouldResume = () => (
    !window.pausedByAd
    && !(
      document.hidden
      || document.mozHidden
      || document.msHidden
      || document.webkitHidden
    )
  );

  if (shouldResume()) {
    cb();
    return;
  }

  const adCheckInterval = setInterval(() => {
    if (!shouldResume()) return;
    clearInterval(adCheckInterval);
    cb();
  }, 200);
};


G.pad = function pad(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
};


G.isImageInCache = function (frameName) {

  var spritesheet = this.checkSheet(frameName)
  if (spritesheet != '') {
    return true;
  } else {
    return game.cache.checkImageKey(frameName);
  }

};


G.checkSheet = function (frame) {

  if (G.spritesheetMap) {
    return G.spritesheetMap[frame] || '';
  } else {
    return this.checkSheetOld();
  }


};

G.checkSheetOld = function () {
  for (var i = 0, len = G.ASSETS.spritesheets.length; i < len; i++) {
    var spritesheet = G.ASSETS.spritesheets[i];
    if (game.cache.checkImageKey(G.ASSETS.spritesheets[i]) && game.cache.getFrameData(G.ASSETS.spritesheets[i]).getFrameByName(frame)) {
      return G.ASSETS.spritesheets[i];
    }
  }
  return '';
};

G.lerp = function (valCurrent, valTarget, lerp, snapRange) {

  if (snapRange && Math.abs(valCurrent - valTarget) <= snapRange) {
    return valTarget;
  }

  return valCurrent + lerp * (valTarget - valCurrent);
};

G.l = function (value) {
  return Math.floor(value * OMT_AssetLoader.getInstance().currentConfigMulti);
};

G.rl = function (value) {

  return Math.floor(value * (1 / OMT_AssetLoader.getInstance().currentConfigMulti));

};

G.lnf = function (value) {
  return value * OMT_AssetLoader.getInstance().currentConfigMulti;
};

G.rnd = function (min, max) {
  return game.rnd.realInRange(min || 0, max || 1);
};

G.rndInt = function (min, max) {
  return game.rnd.between(min, max);
};

G.changeTexture = function (obj, image) {
  // check for destroyed
  if (obj.game === null) return;

  if (typeof image !== 'string') {
    //probalby texture file
    return obj.loadTexture(image);
  }

  var ssheet = this.checkSheet(image);

  if (ssheet == '') {
    obj.loadTexture(image);
  } else {
    obj.loadTexture(ssheet, image);
  };

};

/**
 * deprecated, left in as a few references still existed
 */
G.txt = function (text) {
  return OMT.language.getText(text);
};

G.deltaTime = 1;

G.delta = function () {

  G.deltaTime = Math.min(1.5, game.time.elapsedMS / 16);
  if (game.time.elapsedMS == 17) G.deltaTime = 1;
};

G.rotatePositions = function (positions) {

  var result = [];

  for (var i = 0, len = positions.length; i < len; i += 2) {
    result.push(
      positions[i + 1] * -1,
      positions[i]
    )
  }

  return result;

};

G.loadTexture = G.changeTexture;

G.makeImage = function (x, y, frame, anchor, groupToAdd) {

  var ssheet = this.checkSheet(frame);
  var image;

  if (ssheet == '') {
    image = game.make.image(this.l(x), this.l(y), frame);
  } else {
    image = game.make.image(this.l(x), this.l(y), ssheet, frame);
  }

  if (anchor) {
    if (typeof anchor == 'number') {
      image.anchor.setTo(anchor);
    } else {
      image.anchor.setTo(anchor[0], anchor[1]);
    }
  }

  if (groupToAdd) {
    (groupToAdd.add || groupToAdd.addChild).call(groupToAdd, image);
  } else if (groupToAdd !== null) {
    game.world.add(image);
  }

  return image;
};

G.capitalize = function (string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

G.lengthDirX = function (angle, length, rads) {
  var rads = rads || false;
  if (rads) {
    return Math.cos(angle) * length;
  } else {
    return Math.cos(game.math.degToRad(angle)) * length;
  }
};

G.lengthDirY = function (angle, length, rads) {
  var rads = rads || false;
  if (rads) {
    return Math.sin(angle) * length;
  } else {
    return Math.sin(game.math.degToRad(angle)) * length;
  }
};


G.stopTweens = function (obj) {

  game.tweens._add.forEach(function (tween) {
    if (obj.scale && tween.target == obj.scale) tween.stop();
    if (tween.target == obj) tween.stop();
  });

  game.tweens._tweens.forEach(function (tween) {
    if (obj.scale && tween.target == obj.scale) tween.stop();
    if (tween.target == obj) tween.stop();
  });
};

/**
 * Loads a texture from given url and saves it to cache, or returns the cached instance.
 * Providing `optDoneSyncCallback` will *not* trigger `optDoneCallback` if the task was completed
 * synchronously
 */
G.getExtTexture = function getExtTexture(
  url,
  optDoneCallback, optFailCallback,
  optAsyncStartCallback, optDoneSyncCallback,
  unusedArgument
) {

  return act();

  function act() {
    var flow = G.AsyncUtils.promisifyCallbacks(
      optDoneCallback, optFailCallback,
      optAsyncStartCallback, optDoneSyncCallback
    );

    ensureExtLoaderCreated();

    var textureName = null;

    var cached = getCached(url);
    if (cached) {
      if (cached.futurePromise.isSettled()) {
        if (cached.futurePromise.isSucceed()) {
          return flow.finishSync(cached.futurePromise.getValue());
        } else {
          textureName = cached.textureName;
        }
      } else {
        return flow.startAsync(cached.futurePromise.promise);
      }
    }

    if (textureName === null) {
      textureName = createExtTextureName();
      // FIXME: This is not supported by current `createExtTextureName` implementation
      // var removeFromCacheOnStateChange = unusedArgument;
      // if (removeFromCacheOnStateChange) {
      //   G.extLoader.imagesToRemoveOnStateChange.push(name);
      // }
    }

    var promise = flow.startAsync(
      cache(
        url, textureName,
        extLoad(textureName, url).then(function onSuccess() { return textureName; })
      ).futurePromise.promise
    );

    return promise;
  }

  function ensureExtLoaderCreated() {
    if (!G.extLoader) {
      G.extLoader = new G.ExtLoader(game);
      G.extLoader.crossOrigin = 'anonymous';
    }
  }

  function createExtTextureName() {
    if (!G.extImagesKeys) {
      G.extImagesKeys = [];
    }
    var name = 'extImgBlankName' + G.extImagesKeys.length;
    G.extImagesKeys.push(name);
    return name;
  }

  function getCached(url) {
    return G.extLoader.loadInfoPerUrl[url];
  }

  function cache(url, textureName, promise) {
    var futurePromise = G.AsyncUtils.createFuturePromise();
    var loadInfo = {
      textureName: textureName,
      futurePromise: futurePromise.read
    };
    G.extLoader.loadInfoPerUrl[url] = loadInfo;
    promise.then(futurePromise.control.fulfill, futurePromise.control.reject);
    return loadInfo;
  }

  function extLoad(key, url) {
    return new Promise(function (fulfill, reject) {
      var bindings = {
        success: null,
        failure: null
      };

      act();

      return;

      function act() {
        bindings.success = G.extLoader.onFileComplete.add(
          function (progress, otherKey, success) {
            if (key === otherKey) {
              // FIXME: if this can happen synchronously, binding will still be undefined at this point
              detachBindings();
              success ? fulfill() : reject();
            }
          }
        );

        bindings.failure = G.extLoader.onFileError.add(
          function (otherKey, file) {
            if (key === otherKey) {
              // FIXME: if this can happen synchronously, binding will still be undefined at this point
              detachBindings();
              reject();
            }
          }
        );

        G.extLoader.image(key, url, true);
      }

      function detachBindings() {
        if (bindings.success) {
          bindings.success.detach();
          bindings.success = null;
        }
        if (bindings.failure) {
          bindings.failure.detach();
          bindings.failure = null;
        }
      }
    });
  }

};


G.makeExtImage = function (x, y, url, waitImg, anchor, groupToAdd, tmp, func, callbackOnFail = false) {

  var img;

  G.getExtTexture(
    url, onAsyncDone, null, onGoesAsync, onDoneSynchronously, tmp
  ).catch(function (error) {
    console.warn('Failed to make ext image from "' + url + '":', error);
    if (callbackOnFail && func) {
      func(null);
    }
  });

  function onDoneSynchronously(textureName) {
    img = G.makeImage(x, y, textureName, anchor, groupToAdd);
    func && func.call(img, img);
  }

  function onGoesAsync() {
    img = G.makeImage(x, y, waitImg, anchor, groupToAdd);
  }

  function onAsyncDone(textureName) {
    // in case img was destroyed
    if (img.game !== null) {
      G.changeTexture(img, textureName);
      func && func.call(img, img);
    }
  }

  return img;

};


G.drawCircleSegment = function (gfx, x, y, radius, angleStart, angleFinish, segments) {

  if (angleStart === angleFinish) {
    return gfx;
  }

  if (segments === undefined) { segments = 10 };

  var angleDiff = angleFinish - angleStart;
  var segDiff = angleDiff / segments;

  gfx.moveTo(x, y);
  var points = gfx.currentPath.shape.points;

  for (; angleStart <= angleFinish; angleStart += segDiff) {
    points.push(
      Math.floor(x + G.lengthDirX(angleStart, radius, false)),
      Math.floor(y + G.lengthDirY(angleStart, radius, false))
    )
  };

  points.push(
    Math.floor(x + G.lengthDirX(angleFinish, radius, false)),
    Math.floor(y + G.lengthDirY(angleFinish, radius, false))
  )


  gfx.dirty = true;
  gfx._boundsDirty = true;

  return gfx;


};

G.centerElements = function (list, distanceList, center) {

  if (center === undefined) center = 0;
  if (distanceList === undefined) distanceList = [];

  var wholeWidth = 0;
  var isDistArray = Array.isArray(distanceList);

  list.forEach(function (e, i) {
    wholeWidth += e.width;
    if (isDistArray ? distanceList[i - 1] : distanceList !== undefined) {
      wholeWidth += G.l(isDistArray ? distanceList[i - 1] : distanceList);
    }
  });

  var currentX = center + (wholeWidth * -0.5);

  list.forEach(function (e, i, a) {
    e.x = currentX;
    e.x += e.width * e.anchor.x;

    currentX += e.width;
    if (isDistArray ? distanceList[i - 1] : distanceList !== undefined) {
      currentX += G.l(isDistArray ? distanceList[i] : distanceList);
    }
  });

};

G.centerElements2 = function (list, distance, center) {

  if (center === undefined) center = 0;
  if (distance === undefined) distance = 0;

  var wholeWidth = 0;

  list.forEach(function (e, i) {
    wholeWidth += e.width;
  });

  wholeWidth += distance * (list.length - 1);

  list.forEach(function (e, i, l) {
    if (i == 0) {
      e.left = center + (wholeWidth * -0.5);
    } else {
      e.left = l[i - 1].right + distance;
    }
  });

};


/**
 * new centering call for OMT
 * @param {Array} childList 
 * @param {number} minItempacing 
 * @param {number} maxItempacing 
 * @param {number} maxWidth
 */
G.centerElementsInContainer = function (container, minItempacing, maxItempacing, maxWidth, scaleToFit = true) {

  let childList = container.children;
  let child, childCount = childList.length;
  let totalItemsWidth = 0;

  // get total task item with
  for (let i = 0; i < childCount; i++) {
    child = childList[i];
    if (child.totalWidth) {
      totalItemsWidth += child.totalWidth;
    } else {
      totalItemsWidth = child.getBounds().width;
    }
  }

  // calculate item spread distance
  let distanceBetweenTasks = childCount === 0 ? 0 : Math.max((maxWidth - totalItemsWidth) / (childCount - 1), minItempacing);
  if (distanceBetweenTasks > maxItempacing) distanceBetweenTasks = maxItempacing;

  let xPos = 0;
  for (let i = 0; i < childCount; i++) {

    child = childList[i];
    child.x = xPos;
    if (child.totalWidth) {
      xPos += child.totalWidth;
    } else {
      xPos += child.getBounds().width;
    }
    xPos += distanceBetweenTasks;
  }

  // scale elements to fit within maxWidth
  if (scaleToFit) {
    if (container.width > maxWidth) container.width = maxWidth;
    container.x -= container.width / 2;
    container.scale.y = container.scale.x;
  }
}



G.makeMover = function (obj) {

  if (G.activeMover !== undefined) {
    G.activeMover.destroy();
    G.activeMover.eKey.onDown.removeAll();
  }

  G.activeMover = game.add.image();
  G.activeMover.obj = obj;
  G.activeMover.cursors = game.input.keyboard.createCursorKeys();
  G.activeMover.shiftKey = game.input.keyboard.addKey(Phaser.Keyboard.SHIFT);
  G.activeMover.eKey = game.input.keyboard.addKey(Phaser.Keyboard.E);
  G.activeMover.eKey.onDown.add(function () {
  }, G.activeMover)

  G.activeMover.update = function () {

    var moveVal = this.shiftKey.isDown ? 10 : 2;

    if (this.cursors.down.isDown) {
      obj.y += moveVal;
    }

    if (this.cursors.up.isDown) {
      obj.y -= moveVal;
    }

    if (this.cursors.left.isDown) {
      obj.x -= moveVal;
    }

    if (this.cursors.right.isDown) {
      obj.x += moveVal;
    }

  };

};


G.makeLineEditor = function (interpolation) {

  var be = game.add.group();

  be.interpolation = interpolation || 'linear';
  be.pointsX = [0];
  be.pointsY = [0];



  be.gfx = be.add(game.make.graphics());

  be.shiftKey = game.input.keyboard.addKey(Phaser.Keyboard.SHIFT);

  be.wKey = game.input.keyboard.addKey(Phaser.Keyboard.W);
  be.wKey.onDown.add(function () {

    var xx, yy;

    if (this.children.length > 2) {
      xx = this.children[this.children.length - 1].x;
      yy = this.children[this.children.length - 1].y;
    } else {
      xx = 0;
      yy = 0;
    }

    var newPoint = G.makeImage(xx, yy, 'candy_1');
    newPoint.anchor.setTo(0.5);
    newPoint.scale.setTo(0.1);
    this.add(newPoint);
    this.activeObject = newPoint;
    this.changed = true;
  }, be);

  be.qKey = game.input.keyboard.addKey(Phaser.Keyboard.Q);
  be.qKey.onDown.add(function () {
    if (this.children.length <= 2) return;
    this.removeChildAt(this.children.length - 1);
    if (this.children.length > 3) {
      this.activeObject = this.children[this.children.length - 1];
    } else {
      this.activeObject = null;
    }
    this.changed = true;
  }, be);


  be.aKey = game.input.keyboard.addKey(Phaser.Keyboard.A);
  be.aKey.onDown.add(function () {
    if (!this.activeObject) return;
    var index = this.getChildIndex(this.activeObject);
    if (index == 2) return;
    this.activeObject = this.getChildAt(index - 1);
  }, be);

  be.sKey = game.input.keyboard.addKey(Phaser.Keyboard.S);
  be.sKey.onDown.add(function () {
    if (!this.activeObject) return;
    var index = this.getChildIndex(this.activeObject);
    if (index == this.children.length - 1) return;
    this.activeObject = this.getChildAt(index + 1);
  }, be);

  be.eKey = game.input.keyboard.addKey(Phaser.Keyboard.E);
  be.eKey.onDown.add(function () {
    console.log(JSON.stringify([this.pointsX, this.pointsY]));
  }, be);


  be.cursors = game.input.keyboard.createCursorKeys();

  be.activeObject = null;

  be.preview = G.makeImage(0, 0, 'candy_2', 0.5, be);
  be.preview.width = 8;
  be.preview.height = 8;
  be.preview.progress = 0;

  be.update = function () {

    if (this.activeObject === null) return;

    this.forEach(function (e) {
      if (e == this.activeObject) {
        e.alpha = 1;
      } else {
        e.alpha = 0.5;
      }
    }, this)

    if (this.children.length == 0) return;

    var moveVal = this.shiftKey.isDown ? 3 : 1;

    if (this.cursors.down.isDown) {
      this.activeObject.y += moveVal;
      this.changed = true;
    }
    if (this.cursors.up.isDown) {
      this.activeObject.y -= moveVal;
      this.changed = true;
    }
    if (this.cursors.left.isDown) {
      this.activeObject.x -= moveVal;
      this.changed = true;
    }
    if (this.cursors.right.isDown) {
      this.activeObject.x += moveVal;
      this.changed = true;
    }


    be.preview.progress += 0.01;
    if (be.preview.progress > 1) be.preview.progress = 0;
    be.preview.x = game.math[this.interpolation + 'Interpolation'](this.pointsX, be.preview.progress);
    be.preview.y = game.math[this.interpolation + 'Interpolation'](this.pointsY, be.preview.progress);


    if (this.changed) {
      var pointsX = [];
      var pointsY = [];
      this.pointsX = pointsX;
      this.pointsY = pointsY;
      this.children.forEach(function (e, index) {
        if (index <= 1) return;
        pointsX.push(e.x);
        pointsY.push(e.y);
      });

      this.gfx.clear();
      this.gfx.beginFill(0xff0000, 1);
      for (var i = 0; i < 200; i++) {
        this.gfx.drawRect(
          game.math[this.interpolation + 'Interpolation'](pointsX, i / 200),
          game.math[this.interpolation + 'Interpolation'](pointsY, i / 200),
          3, 3
        );
      }
    }
  }


  return be;

};


G.lineUtils = {

  getWholeDistance: function (pointsX, pointsY) {

    var wholeDistance = 0;
    for (var i = 1; i < pointsX.length; i++) {
      wholeDistance += game.math.distance(pointsX[i - 1], pointsY[i - 1], pointsX[i], pointsY[i]);
    }
    return wholeDistance;

  },

  findPointAtDitance: function (pointsX, pointsY, dist) {

    var soFar = 0;
    for (var i = 1; i < pointsX.length; i++) {
      var currentDistance = game.math.distance(pointsX[i - 1], pointsY[i - 1], pointsX[i], pointsY[i]);
      if (currentDistance + soFar > dist) {
        var angle = game.math.angleBetween(pointsX[i - 1], pointsY[i - 1], pointsX[i], pointsY[i]);
        return [
          pointsX[i - 1] + G.lengthDirX(angle, dist - soFar, true),
          pointsY[i - 1] + G.lengthDirY(angle, dist - soFar, true)
        ]
      } else {
        soFar += currentDistance;
      }

    }
    return [pointsX[pointsX.length - 1], pointsY[pointsY.length - 1]];

  },

  spreadAcrossLine: function (pointsX, pointsY, elementsList, propName1, propName2) {


    var wholeDistance = this.getWholeDistance(pointsX, pointsY);
    var every = wholeDistance / (elementsList.length - 1);

    for (var i = 0; i < elementsList.length; i++) {
      var point = this.findPointAtDitance(pointsX, pointsY, every * i);
      elementsList[i][propName1 || 'x'] = point[0];
      elementsList[i][propName2 || 'y'] = point[1];
    }

  },

  spreadOnNodes: function (pointsX, pointsY, elementsList, propName1, propName2) {


    for (var i = 0; i < pointsX.length; i++) {
      if (typeof elementsList[i] === 'undefined') return;
      elementsList[i][propName1 || 'x'] = pointsX[i];
      elementsList[i][propName2 || 'y'] = pointsY[i];
    }

  }
};



G.changeSecToTimerFormat = function (sec, forceFormat) {

  var sec_num = parseInt(sec, 10); // don't forget the second param

  var fD = forceFormat ? forceFormat.toUpperCase().indexOf('D') !== -1 : false;
  var fH = forceFormat ? forceFormat.toUpperCase().indexOf('H') !== -1 : false;

  var days = Math.floor(sec_num / 86400);
  var hours = Math.floor((sec_num - (days * 86400)) / 3600);
  var minutes = Math.floor((sec_num - (days * 86400) - (hours * 3600)) / 60);
  var seconds = sec_num - (days * 86400) - (hours * 3600) - (minutes * 60);


  var result = G.zeroPad(minutes) + ':' + G.zeroPad(seconds);

  if (hours > 0 || days > 0 || fH) {
    result = G.zeroPad(hours) + ':' + result;
  }

  if (days > 0 || fD) {
    result = G.zeroPad(days) + ':' + result;
  }

  return result;

};

G.changeSecToDHMS = function (sec) {
  var secNum = parseInt(sec, 10); // don't forget the second param
  var days = Math.floor(secNum / 86400);
  var hours = Math.floor((secNum - (days * 86400)) / 3600);
  var minutes = Math.floor((secNum - (days * 86400) - (hours * 3600)) / 60);
  var seconds = secNum - (days * 86400) - (hours * 3600) - (minutes * 60);

  return [this.zeroPad(days),
  this.zeroPad(hours),
  this.zeroPad(minutes),
  this.zeroPad(seconds)];
}

G.changeSecToHMS = function (sec) {
  var secNum = parseInt(sec, 10); // don't forget the second param
  var hours = Math.floor(secNum / 3600);
  var minutes = Math.floor((secNum - (hours * 3600)) / 60);
  var seconds = secNum - (hours * 3600) - (minutes * 60);

  return [
    this.zeroPad(hours),
    this.zeroPad(minutes),
    this.zeroPad(seconds)];
}

G.changeSecToMS = function (sec) {
  var secNum = parseInt(sec, 10); // don't forget the second param
  var minutes = Math.floor(secNum / 60);
  var seconds = secNum - (minutes * 60);

  return [
    this.zeroPad(minutes),
    this.zeroPad(seconds)];
}



G.zeroPad = function (number) {
  return number < 10 ? "0" + number : number;
};

G.makeTextButton = function (x, y, text, style, func, context) {

  var txt = game.make.text(x, y, text, style)
  txt.inputEnabled = true;
  txt.input.useHandCursor = true;
  txt.hitArea = new Phaser.Rectangle(0, 0, txt.width, txt.height);
  txt.events.onInputDown.add(func, context || null);

  return txt;

};



if (typeof G == 'undefined') G = {};

G.Utils = {

  wrapFunction: function wrapFunction(
    obj,
    funcName,
    optCustomFuncBefore,
    optCustomFuncAfter,
    optCustomFunctionInstead
  ) {
    var preFunc = optCustomFuncBefore;
    var insteadFunc = optCustomFunctionInstead;
    var postFunc = optCustomFuncAfter;
    var originalFunc = obj[funcName];
    obj[funcName] = wrapped;

    return revoke;

    function wrapped(/*arguments*/) {

      preFunc && preFunc.apply(this, arguments);

      var result;
      if (insteadFunc) {
        result = insteadFunc.apply(
          this,
          [originalFunc].concat(Array.prototype.slice.call(arguments))
        );
      } else {
        result = originalFunc.apply(this, arguments);
      }

      postFunc && postFunc.apply(
        this,
        [result, overrideResult].concat(Array.prototype.slice.call(arguments))
      );

      return result;

      function overrideResult(newResult) {
        result = newResult;
      }
    }

    function revoke() {
      if (obj[funcName] === wrapped) {
        obj[funcName] = originalFunc;
      } else {
        console.warn('Unable to properly revoke function wrapper from %O ("%s")', obj, funcName);
        preFunc = null;
        insteadFunc = null;
        postFunc = null;
      }
    }
  },

  debugPrompt: function utilsPrompt(message) {
    return new Promise(function (resolve, reject) {
      const blocker = document.createElement("div");
      blocker.style.position = "fixed";
      blocker.style.width = "100%";
      blocker.style.height = "100%";
      blocker.style.top = '0%';
      blocker.style.left = '0%';
      blocker.style.opacity = .5;
      blocker.style.backgroundColor = "#000000";

      var popup = document.createElement("div");
      popup.style.position = "fixed";
      popup.style.width = "200px";
      popup.style.height = "100px";
      popup.style.backgroundColor = "white";
      popup.style.top = "50%";
      popup.style.left = "50%";
      popup.style.marginLeft = "-100px";
      popup.style.marginTop = "-50px";
      popup.style.padding = "10px";

      let btn = document.createElement("button");
      btn.innerHTML = "cancel";
      btn.style.fontSize = "1.1em";
      btn.style.top = "45%";
      btn.style.left = "5%";
      btn.style.position = "absolute";
      popup.appendChild(btn);
      btn.onclick = (function () {
        popup.parentElement.removeChild(popup);
        blocker.parentElement.removeChild(blocker);
        resolve("");
      }).bind(btn);

      var msg = document.createElement("div");
      var txt = document.createTextNode(message);
      msg.appendChild(txt);
      popup.appendChild(msg);

      var input = document.createElement("input");
      input.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          resolve(input.value);
          destroyDiv();
        } else if (event.key === "Escape") {
          resolve("");
          destroyDiv();
        }
        event.stopPropagation();
      });
      popup.appendChild(input);

      document.body.appendChild(blocker);
      document.body.appendChild(popup);
      input.focus();

      function destroyDiv() {
        popup.parentElement.removeChild(popup);
        blocker.parentElement.removeChild(blocker);
      }
    });
  },

  /**
   * create a yes / no confirm promp
   */
  confirmPrompt: function confirmPrompt(message, callback) {
    return new Promise((resolve) => {
      const blocker = document.createElement("div");
      blocker.style.position = "fixed";
      blocker.style.width = "100%";
      blocker.style.height = "100%";
      blocker.style.top = '0%';
      blocker.style.left = '0%';
      blocker.style.opacity = .5;
      blocker.style.backgroundColor = "#000000";

      const popup = document.createElement("div");
      popup.style.position = "fixed";
      popup.style.width = "200px";
      popup.style.height = "100px";
      popup.style.backgroundColor = "white";
      popup.style.top = "50%";
      popup.style.left = "50%";
      popup.style.marginLeft = "-100px";
      popup.style.marginTop = "-50px";
      popup.style.padding = "10px";

      const msg = document.createElement("div");
      const txt = document.createTextNode(message);
      msg.style.top = "10%";
      msg.style.left = "10%";
      msg.style.position = "absolute";
      msg.style.width = "80%";
      msg.style.textAlign = "center";
      msg.appendChild(txt);
      popup.appendChild(msg);

      let btn = document.createElement("button");
      btn.innerHTML = "NO";
      btn.style.fontSize = "1.4em";
      btn.style.top = "60%";
      btn.style.left = "20%";
      btn.style.position = "absolute";
      popup.appendChild(btn);
      btn.onclick = (function () {
        popup.parentElement.removeChild(popup);
        blocker.parentElement.removeChild(blocker);
        resolve(false);
      }).bind(btn);

      btn = document.createElement("button");
      btn.innerHTML = "YES";
      btn.style.fontSize = "1.4em";
      btn.style.top = "60%";
      btn.style.right = "20%";
      btn.style.position = "absolute";
      btn.onclick = (function () {
        popup.parentElement.removeChild(popup);
        blocker.parentElement.removeChild(blocker);
        resolve(true);
      }).bind(btn);
      popup.appendChild(btn);

      document.body.appendChild(blocker);
      document.body.appendChild(popup);
    });
  },

  resetInput: function resetInput(game) {
    game.input.pointers.forEach(function (pointer) {
      pointer.active = false;
    });
  },

  /**
   * @param {Array<T>} arr Array of elements to randomly return
   * @param {(element: T) => Number} getWeightFunc
   * @returns {T}
   */
  getRandomWeightedElement: function getRandomWeightedElement(arr, getWeightFunc) {
    var sum = arr.reduce(function (total, element) {
      return total + getWeightFunc(element);
    }, 0);

    var rnd = game.rnd.realInRange(0, 1) * sum;

    for (var index = 0, len = arr.length; index < len; index++) {
      rnd -= getWeightFunc(arr[index]);
      if (rnd <= 0) {
        return arr[index];
      }
    }
  },

  setIgnoreChildrenRec: function setIgnoreChildrenRec(obj, ignore) {
    obj.ignoreChildInput = ignore;
    if (obj.children) {
      obj.children.forEach(function (child) { setIgnoreChildrenRec(child, ignore); });
    }
  },

  warnDeprecationUsage: function warnDeprecationUsage(message) {
    debugger;
    console.error(message);
    try { G.Utils.SentryLog.logError(message); } catch (e) { }
  },

  loadScript: function loadScript(url) {
    return new Promise(function (fulfill, reject) {
      var script = document.createElement('script');
      script.onload = fulfill;
      script.onerror = reject;
      script.src = url;
      document.head.appendChild(script);
    });
  },

  clone: function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  },

  // detach bindings when object is destroyed
  cleanUpOnDestroy: function cleanUpOnDestroy(obj, binding) {
    var onDestroySignal;

    if (obj instanceof Phaser.Group) {
      onDestroySignal = obj.onDestroy
    } else {
      onDestroySignal = obj.events.onDestroy;
    }

    onDestroySignal.addOnce(binding.detach, binding);

    return binding;
  },

  cacheText: function (cacheLabel, txt, font, fontSize, tint) {

    var txt = game.make.bitmapText(0, 0, font, txt, fontSize);
    txt.tint = tint || 0xffffff;
    txt.updateCache();

    var rt = game.make.renderTexture(txt.width, txt.height, cacheLabel, true);
    rt.render(txt);

    txt.destroy();

  },

  cacheGText: function (cacheLabel, txt, style) {

    var txt = new G.Text(0, 0, txt, style, 0);
    var rt = game.make.renderTexture(txt.width, txt.height, cacheLabel, true);
    rt.render(txt);
    txt.destroy();

  },

  lerp: function (valCurrent, valTarget, lerp, snapRange) {
    if (snapRange && Math.abs(valCurrent - valTarget) <= snapRange) {
      return valTarget;
    }
    return valCurrent + lerp * (valTarget - valCurrent);
  },

  copyToClipboard: function (text) {

    if (!this.copyArea) {
      this.copyArea = document.createElement("textarea");
      this.copyArea.style.positon = 'fixed';
      this.copyArea.style.opacity = 0;
      document.body.appendChild(this.copyArea);

    }

    this.copyArea.value = text;
    this.copyArea.select();
    document.execCommand('copy');

  },

  replaceAll: function (string, search, replacement) {
    return string.split(search).join(replacement);
  },

  getParentsScaleX: function (obj, rec) {

    if (obj == game.stage) {
      return 1;
    } else {
      return G.Utils.getParentsScaleX(obj.parent, true) * (!rec ? 1 : obj.scale.x);
    }

  },

  getParentsScaleY: function (obj, rec) {

    if (obj == game.stage) {
      return 1;
    } else {
      return G.Utils.getParentsScaleY(obj.parent, true) * (!rec ? 1 : obj.scale.y);
    }

  },

  makeTextButton: function (x, y, label, func, context, style) {

    var txt = game.add.text(x, y, label, style);
    txt.inputEnabled = true;
    txt.input.useHandCursor = true;
    txt.hitArea = new Phaser.Rectangle(0, 0, txt.width, txt.height);
    txt.events.onInputDown.add(func, context);
    return txt;

  },

  injectCSS: function (css) {

    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = css;
    document.getElementsByTagName('head')[0].appendChild(style);

  },

  toClientX: function (ingameX) {
    var marginLeft = parseInt(game.canvas.style.marginLeft) || 0;
    return marginLeft + (ingameX / game.width) * game.canvas.clientWidth;
  },

  toClientY: function (ingameY) {
    var marginTop = parseInt(game.canvas.style.marginTop) || 0;
    return marginTop + (ingameY / game.height) * game.canvas.clientHeight;
  },

  clientXToWorldX: function (clientX) {
    var marginLeft = parseInt(game.canvas.style.marginLeft) || 0;

    clientX -= marginLeft;
    var canvasStyleWidth = parseInt(game.canvas.style.width);
    var canvasStyleHeight = parseInt(game.canvas.style.height);
    var canvasContextWidth = parseInt(game.canvas.width);
    var canvasContextHeight = parseInt(game.canvas.height);

    var ratio = canvasContextWidth / canvasStyleWidth;

    return clientX * ratio;


  },

  clientYToWorldY: function (clientY) {

    var marginTop = parseInt(game.canvas.style.marginTop) || 0;

    clientY -= marginTop;
    var canvasStyleWidth = parseInt(game.canvas.style.width);
    var canvasStyleHeight = parseInt(game.canvas.style.height);
    var canvasContextWidth = parseInt(game.canvas.width);
    var canvasContextHeight = parseInt(game.canvas.height);

    var ratio = canvasContextHeight / canvasStyleHeight;

    return clientY * ratio;

  },

  isWorldVisible: function isWorldVisible(object) {
    var temp = object;
    while (temp) {
      if (!temp.visible) return false;
      temp = temp.parent;
    }
    return true;
  },

  getImageURI: function (img) {

    if (!this._bmpMarker) this._bmpMarker = G.makeImage(0, 0, null, 0, null);
    if (!this._bmp) this._bmp = game.make.bitmapData();

    this._bmp.clear();
    G.changeTexture(this._bmpMarker, img);
    this._bmp.resize(this._bmpMarker.width, this._bmpMarker.height);
    this._bmp.draw(this._bmpMarker);
    return this._bmp.canvas.toDataURL();
  },

  getRT: function (rtName) {
    return game.cache.getRenderTexture(rtName).texture;
  },

  find1stObjectWithName: function (parent, name) {
    if (!parent) return null;
    if (parent.name === name) return parent;
    if (parent.children) {
      for (var i = 0; i < parent.children.length; ++i) {
        var result = G.Utils.find1stObjectWithName(parent.children[i], name);
        if (result) return result;
      }
    }
    return null;

  },

  debugError: function debugError(/*arguments*/) {
    console.error.apply(console, arguments);
    var localhost = false;
    if (window && window.location && window.location.hostname === "localhost") {
      localhost = true;
    }
    if (localhost) {
      eval("debugger");
    }
  },

  defined: function defined(/*arguments*/) {
    for (var i = 0; i < arguments.length; ++i) {
      if (arguments[i] !== undefined) return arguments[i];
    }
  }

};

G.lineCircleColl = function (LINE, C, point) {

  var A = LINE.start;
  var B = LINE.end;

  var LAB = Math.sqrt(Math.pow(B.x - A.x, 2) + Math.pow(B.y - A.y, 2))

  var Dx = (B.x - A.x) / LAB
  var Dy = (B.y - A.y) / LAB

  var t = Dx * (C.x - A.x) + Dy * (C.y - A.y)

  var Ex = t * Dx + A.x
  var Ey = t * Dy + A.y

  var LEC = Math.sqrt(Math.pow(Ex - C.x, 2) + Math.pow(Ey - C.y, 2))

  if (LEC < C.radius) {

    var dt = Math.sqrt((C.radius * C.radius) - (LEC * LEC))

    var Fx = (t - dt) * Dx + A.x;
    var Fy = (t - dt) * Dy + A.y;

    var Gx = (t + dt) * Dx + A.x;
    var Gy = (t + dt) * Dy + A.y;

    var FtoLength = game.math.distance(A.x, A.y, Fx, Fy);
    var GtoLength = game.math.distance(A.x, A.y, Gx, Gy);

    if (FtoLength < GtoLength) {
      if (LINE.length > FtoLength) {
        point.setTo(Fx, Fy);
        return point;
      } else {
        return false;
      }
    } else {
      if (LINE.length > GtoLength) {
        point.setTo(Gx, Gy);
        return point;
      } else {
        return false;
      }
    }

  } else {
    return false;
  }

};

G.getRT = function (rtName) {

  var rt = game.cache.getRenderTexture(rtName);
  if (!rt) return null;
  return rt.texture;
};


G.numberDot = function (price) {

  price = price.toString();
  var result = '';

  var n = 0;
  for (var i = price.length - 1; i >= 0; i--) {
    result = price[i] + result;
    n++;
    if (n == 3 && i !== 0) {
      result = '.' + result;
      n = 0;
    }
  }

  return result;

};


G.guid = function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
};